<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'ExistingEvidence',

  data () {
    return {
    }
  },

  methods: {}
}
</script>

<style lang='scss' scoped>

</style>
